import { Me } from '@nrdy-marketing-engine/cart/@types/me';
import React from 'react';
import useUser from './use-user';

export interface UserContextInterface {
  clientID: string;
  user: Me;
  userRefetch?: () => void;
}

export const UserCtx = React.createContext<UserContextInterface | null>({
  clientID: null,
  user: null,
});

export function UserProvider(props: {
  children: React.ReactNode;
  /** The userContext passed down from the server-side, if present, to skip further fetches */
  userContext?: UserContextInterface;
}) {
  const { children } = props;
  const { clientID, user, userRefetch } = useUser(props.userContext);

  return <UserCtx.Provider value={{ clientID, user, userRefetch }}>{children}</UserCtx.Provider>;
}

// custom hook, main way of interaction with context
// largely for readability and making sure that you're not trying to use it without the expected provider
export const useUserContext = () => {
  const context = React.useContext(UserCtx);

  if (context === undefined) {
    throw new Error('useUserContext can only be used within an UserProvider');
  }

  return context;
};
